import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import cookiesImg from "../assets/cokies-image.jpeg";

const STORAGE_KEY = "bq_cookie_popup_dismissed_until";
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const CookiePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      const dismissedUntil = localStorage.getItem(STORAGE_KEY);
      if (dismissedUntil && Date.now() < Number(dismissedUntil)) {
        return;
      }
    } catch (e) {
      // Ignore localStorage errors (e.g., incognito)
    }

    // Show popup after a smooth gentle delay
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = (e) => {
    if (e) e.stopPropagation();
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + ONE_DAY_MS));
    } catch (err) {
      // Ignore
    }
    setIsOpen(false);
  };

  // Close on Escape key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        handleClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6 bg-black/75 backdrop-blur-sm animate-fade-in"
      onClick={handleClose}
      role="dialog"
      aria-modal="true"
      aria-label="Grand Opening Offer"
    >
      <div
        className="relative w-full max-w-[440px] sm:max-w-[480px] bg-white rounded-3xl overflow-hidden shadow-2xl border border-white/20 transform transition-all duration-300 scale-100 animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Floating Close Button */}
        <button
          onClick={handleClose}
          type="button"
          aria-label="Close popup"
          className="absolute top-3 right-3 z-20 w-9 h-9 flex items-center justify-center rounded-full bg-black/60 hover:bg-black text-white hover:text-white transition-all duration-200 shadow-lg group focus:outline-none focus:ring-2 focus:ring-[#9b1c2e]"
        >
          <svg
            className="w-5 h-5 transform group-hover:rotate-90 transition-transform duration-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Poster Image */}
        <div className="relative overflow-hidden bg-gradient-to-b from-amber-50 to-orange-50">
          <Link
            to="/best-bbq-restaurant-in-pudukkottai"
            onClick={handleClose}
            className="block group"
          >
            <img
              src={cookiesImg}
              alt="Grand Opening Pudukkottai - Barbequeen Restaurant"
              className="w-full h-auto object-contain max-h-[70vh] sm:max-h-[520px] mx-auto transition-transform duration-300 group-hover:scale-[1.01]"
              loading="eager"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;
